import { ArrayUtils, get } from "@green24/npm-javascript-utils";

export class StorageUtils {
	static getAllServices(unit) {
		return get(unit , "frames", []).map(frame => frame.blocks.map(block => block.services)).flat(2);
	}

	static getAvailableServices(services) {
		return services.filter(service => service.enabled && !service.occupied);
	}

	static getAllServiceTypes(services) {
		return services.map(service => service.serviceType);
	}

	static getAvailableServiceTypes(services) {
		return services.filter(service => service.enabled && !service.occupied).map(service => service.serviceType);
	}

	static getUniqueServiceTypes(serviceTypes) {
		return ArrayUtils.extractUnique(serviceTypes, "id")
	}

	static getServiceTypeForSelectionFromUnit(unit) {
		return this.getUniqueServiceTypes(this.getAvailableServiceTypes(this.getAvailableServices(this.getAllServices(unit))));
	}

	static findServiceTypeFromUnitByID(unit, serviceTypeID) {
		return ArrayUtils.findByID(this.getAllServiceTypes(this.getAllServices(unit)), serviceTypeID);
	}

	static getTimeBracketByID(brackets, id) {
		return ArrayUtils.findByID(brackets, id);
	}

	static getTimeBrackets(service) {
		return get(service, "tariff.timeBrackets", []);
	}

	static findBracketFromUnitByID(unit, bracketID) {
		return this.getAllServices(unit).find(service => this.getTimeBracketByID(this.getTimeBrackets(service), bracketID));
	}
}
